var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 12.4194V3.5C13.5 2.94771 13.0523 2.5 12.5 2.5C11.9477 2.5 11.5 2.94771 11.5 3.5V12.4194L8.12469 9.71913C7.69343 9.37412 7.06414 9.44404 6.71913 9.87531C6.37412 10.3066 6.44404 10.9359 6.87531 11.2809L11.563 15.031C11.6213 15.0777 11.6823 15.1194 11.7453 15.1561C11.9287 15.3668 12.1988 15.5 12.5 15.5C12.8012 15.5 13.0713 15.3668 13.2547 15.1561C13.3177 15.1194 13.3787 15.0777 13.437 15.031L18.1247 11.2809C18.556 10.9359 18.6259 10.3066 18.2809 9.87531C17.9359 9.44404 17.3066 9.37412 16.8753 9.71913L13.5 12.4194ZM4.5 14.5C5.05228 14.5 5.5 14.9477 5.5 15.5V19.5H19.5V15.5C19.5 14.9477 19.9477 14.5 20.5 14.5C21.0523 14.5 21.5 14.9477 21.5 15.5V20C21.5 20.8284 20.8284 21.5 20 21.5H5C4.17157 21.5 3.5 20.8284 3.5 20V15.5C3.5 14.9477 3.94772 14.5 4.5 14.5Z",
    fill: "#2F2F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDownload);
export default __webpack_public_path__ + "static/media/button-download.6de94feb394d0d31dacb466e1c165293.svg";
export { ForwardRef as ReactComponent };